import React from 'react';
import { StyleSheet, Pressable, Image } from 'react-native';
import { YStack } from '@tamagui/stacks';
import { Text } from '@tamagui/core';
import { COLORS } from '@/constants/colors';
import type { Gift } from '@/data/giftsData';

type GiftItemProps = {
  gift: Gift;
  isSelected: boolean;
  onPress: () => void;
  isDark?: boolean;
};

const GiftItem = React.memo<GiftItemProps>(({ gift, isSelected, onPress, isDark }) => {
  return (
    <YStack alignItems="center" gap="$2">
      <Pressable onPress={onPress} style={{ width: '100%' }}>
        <YStack
          alignItems="center"
          justifyContent="center"
          width={64}
          height={64}
          borderRadius={12}
          borderWidth={1}
          borderColor={
            isSelected
              ? COLORS.PRIMARY
              : isDark
              ? 'rgba(255, 255, 255, 0.2)'
              : 'rgba(0, 0, 0, 0.1)'
          }
          backgroundColor={
            isSelected
              ? COLORS.PRIMARY
              : isDark
              ? 'rgba(255, 255, 255, 0.05)'
              : 'rgba(0, 0, 0, 0.02)'
          }
          style={[
            styles.giftCard,
            isSelected && styles.selectedGift,
          ]}
        >
          <Image
            source={gift.image}
            style={{ width: 48, height: 48 }}
            resizeMode="contain"
          />
        </YStack>
      </Pressable>
      <Text
        fontSize={14}
        fontWeight="700"
        color={isDark ? COLORS.WHITE : COLORS.BLACK}
        textAlign="center"
      >
        {gift.price} zł
      </Text>
    </YStack>
  );
});

const styles = StyleSheet.create({
  giftCard: {
    borderWidth: 2,
    borderColor: 'transparent',
  },
  selectedGift: {
    borderColor: COLORS.PRIMARY,
  },
});

GiftItem.displayName = 'GiftItem';

export default GiftItem;


